export const MERCHANTS_DISTRIBUTION_URL =
  window._env_?.VUE_APP_GET_MERCHANTS_DISTRIBUTION_URL ??
  process.env.VUE_APP_GET_MERCHANTS_DISTRIBUTION_URL
export const MERCHANTS_DISTRIBUTION_TOKEN =
  window._env_?.VUE_APP_GET_MERCHANTS_DISTRIBUTION_TOKEN ??
  process.env.VUE_APP_GET_MERCHANTS_DISTRIBUTION_TOKEN
export const API_URL = (window._env_?.VUE_APP_API_URL ?? process.env.VUE_APP_API_URL) || 'localhost'
export const JOGET_API_URL =
  (window._env_?.VUE_APP_JOGET_API_URL ?? process.env.VUE_APP_JOGET_API_URL) || 'localhost'
export const GET_ENDPOINT_URL =
  (window._env_?.VUE_APP_GET_ENDPOINT_URL ?? process.env.VUE_APP_GET_ENDPOINT_URL) || 'localhost'
export const GET_SYSTEM_CONFIG_URL =
  (window._env_?.VUE_APP_GET_SYSTEM_CONFIG_URL ?? process.env.VUE_APP_GET_SYSTEM_CONFIG_URL) ||
  'localhost'
export const GET_SYSTEM_CONFIG_CCRP =
  (window._env_?.VUE_APP_GET_CCRP_CONFIG ?? process.env.VUE_APP_GET_CCRP_CONFIG) || 'localhost'
export const DOMAIN_TITLE =
  (window._env_?.VUE_APP_DOMAIN_TITLE ?? process.env.VUE_APP_DOMAIN_TITLE) || 'MyTapio CRM'
export const GOOGLE_API_TOKEN =
  window._env_?.VUE_APP_GOOGLE_API_TOKEN ?? process.env.VUE_APP_GOOGLE_API_TOKEN
export const TOKEN_INSIDE =
  (window._env_?.VUE_APP_INSIDE_TOKEN ?? process.env.VUE_APP_INSIDE_TOKEN) || 'TOKEN_INSIDE'
export const GET_SYSTEM_CONFIG_KEY =
  window._env_?.VUE_APP_GET_SYSTEM_CONFIG_KEY ?? process.env.VUE_APP_GET_SYSTEM_CONFIG_KEY
